// extracted by mini-css-extract-plugin
var _1 = "EF38J";
var _2 = "jjr0M";
export { _1 as "base", _2 as "message" }
